import { EnumObject } from '@pflegia/types/common/enums/enum-object';
import { InviteChannel } from '@pflegia/types/common/match/invite-channel';

export const InviteChannelOverride = {
  ...InviteChannel,
  Unset: 'unset',
} as const;

export type InviteChannelOverride = EnumObject<typeof InviteChannelOverride>;
